var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-collection',{attrs:{"value":_vm.value,"mode":_vm.mode,"filter-type":"term","dereferenceItems":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }